<template>
  <div id="post-card-bottom">
    <!-- 隱私設定 -->
    <div @click="privacyDialog = true" class="privacy">
      <i class="fal fa-user-tag fa-2x"></i>
      <p>隱私設定</p>
      <div>{{ privacySelection.label }}</div>
      <i class="far fa-chevron-right"></i>
    </div>
    <hr />
    <!-- 隱私設定Dialog -->
    <q-dialog id="privacyDialog" v-model="privacyDialog">
      <q-card>
        <q-card-section v-for="item in privacyOptions" :key="item.value">
          <q-btn flat @click="setPrivacy(item), SET_PRIVACY(privacySelection.value)" color="white" text-color="black" :label="item.label" v-close-popup />
        </q-card-section>
      </q-card>
    </q-dialog>
    <!-- 好友標記 -->
    <div @click="friendDialog = true" class="friends">
      <i class="fal fa-user-tag fa-2x"></i>
      <p>標記好友</p>
      <div>{{ displayFriendName }}</div>
      <i class="far fa-chevron-right"></i>
    </div>
    <hr />
    <!-- 好友標記Dialog -->
    <q-dialog id="friendDialog" v-model="friendDialog" :maximized="maximizedToggle" transition-show="slide-up" transition-hide="slide-down">
      <q-card>
        <div class="top">
          <!-- Title -->
          <div class="friend-title">
            <p>標記好友</p>
            <q-btn flat icon="close" v-close-popup></q-btn>
          </div>
          <hr class="cool-hr" />
          <!-- 搜尋 -->
          <div class="search">
            <q-input outlined :dense="dense" v-model="searchText" color="lale-blue" placeholder="搜尋" />
            <q-btn @click="SET_FRIEND(friendSelection)" color="lale-primary" v-close-popup>確定({{ friendSelection.length }})</q-btn>
          </div>
          <p class="frinedNmuber">{{ friendList.length }}位好友</p>
        </div>
        <!-- 朋友列表 -->
        <div class="scroll-container">
          <div class="friendList" v-for="item in friendList" v-show="filter(item.friend_displayName)" :key="item.friend_userId">
            <q-checkbox color="lale-blue" v-model="friendSelection" :val="item" />
            <img :src="item.friend_avatarUrl && item.friend_avatarUrl !== 'null' ? item.friend_avatarUrl : require('@/assets/img/defultPerson1.png')" />
            <p>{{ item.friend_displayName }}</p>
          </div>
        </div>
        <!-- 預覽圖片 -->
        <div class="preview">
          <div v-for="(item, key) in friendAvatar" :key="item" class="img-box">
            <span @click="removeImg(key)" class="fa-stack">
              <i class="fas fa-circle fa-stack-2x"></i>
              <i class="far fa-circle fa-stack-2x"></i>
              <i class="far fa-times fa-stack-1x fa-inverse"></i>
            </span>
            <img :src="item && item !== 'null' ? item : require('@/assets/img/defultPerson1.png')" />
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: 'EditPostBottom',
  data() {
    return {
      privacySelection: {},
      privacyDialog: false,
      privacyOptions: [
        { label: '所有人可見', value: 'ALL' },
        { label: '朋友可見', value: 'FRIEND' },
        { label: '自己可見', value: 'ONLYME' }
      ],
      friendSelection: [],
      friendDialog: false,
      friendList: [],
      displayFriendName: '',
      searchText: '',
      maximizedToggle: true,
      dense: true,
      // 測試用好友
      testData: [
        {
          friend_userId: '@aa:lalepass.lale.im',
          friend_displayName: 'kayla',
          friend_avatarUrl: ''
        },
        {
          friend_userId: '@cipher:lalepass.lale.im',
          friend_displayName: 'cipher',
          friend_avatarUrl: 'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/tZpZcWYjQwktqRpvJgSuGvwZ'
        },
        {
          friend_userId: '@keith.liu:lalepass.lale.im',
          friend_displayName: 'keith',
          friend_avatarUrl: 'https://mtx.lale.im:8443/_matrix/media/r0/download/lalepass.lale.im/SKTLcTHDkHUsBOnWWpEaINFZ'
        }
      ]
    };
  },
  computed: {
    friendName() {
      return this.friendSelection.map(item => {
        return item.friend_displayName;
      });
    },
    friendAvatar() {
      return this.friendSelection.map(item => {
        return item.friend_avatarUrl;
      });
    }
  },
  methods: {
    ...mapMutations('EditPostModule', ['SET_PRIVACY', 'SET_FRIEND']),
    // 叫手機拿資料
    getMyFriendList() {
      let myUserAgent = navigator.userAgent;
      let isiOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        try {
          if (window.webkit.messageHandlers.getMyFriendList === undefined) {
            return false;
          } else {
            window.webkit.messageHandlers.getMyFriendList.postMessage('');
          }
        } catch (exception) {
          console.log(exception);
          return false;
        }
      } else {
        try {
          if (window.LaleTon.getMyFriendList === undefined) {
            return false;
          } else {
            window.LaleTon.getMyFriendList('');
          }
        } catch (exception) {
          console.log(exception);
          return false;
        }
      }
    },

    // 搜尋好友
    filter(payload) {
      if (payload.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) {
        return true;
      } else {
        return false;
      }
    },
    setPrivacy(payload) {
      this.privacySelection = payload;
    },
    removeImg(payload) {
      this.friendSelection.splice(payload, 1);
    }
  },
  created() {
    this.privacySelection = { label: '所有人可見', value: 'ALL' };
  },
  mounted() {
    // 跟手機拿資料
    this.getMyFriendList();
    window.returnFriendList = res => {
      this.friendList = JSON.parse(res).friendList;
    };
  },
  watch: {
    // 顯示tag朋友數量
    friendName() {
      if (this.friendName.length === 0) {
        this.displayFriendName = '';
      } else if (this.friendName.length === 1) {
        this.displayFriendName = `與 ${this.friendName[0]}`;
      } else {
        this.displayFriendName = `與 ${this.friendName[0]} 和其他${this.friendName.length - 1}人`;
      }
    },
    friendSelection() {
      console.log(this.friendSelection);
    }
  }
};
</script>

<style lang="scss" scoped>
#post-card-bottom {
  width: 90vw;
  margin: auto;
}
hr {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  margin-top: 0;
}
.privacy,
.friends {
  display: grid;
  grid-template-columns: 40px 85px auto 40px;
  height: 7vh;
  i {
    align-self: center;
    &:last-child {
      text-align: right;
    }
  }

  p,
  div {
    font-size: 15px;
    margin: 0;
    align-self: center;
    justify-self: center;
  }
  .fa-greater-than {
    color: #ccc;
    font-size: 20px;
  }
}
// 隱私Dialog
#privacyDialog {
  .q-card__section--vert {
    padding: 0;
  }
  .q-btn {
    width: 50vw;
    height: 10vh;
  }
}
// 好友Dialog
#friendDialog {
  position: relative;
  .q-card {
    border-radius: 11px 11px 0 0 !important;
    top: 10vh;
  }
}
.top {
  height: 20vh;
}
.friend-title {
  display: flex;
  p {
    font-size: 16px;
    color: #777;
    margin: 1.5vh auto;
    position: relative;
    left: 24px;
  }
  .q-btn {
    color: #999;
  }
}
.search {
  display: flex;
  justify-content: center;
  margin-top: 3vw;
  margin-bottom: 2vw;
  .q-btn {
    margin-left: 1vw;
  }
}
.frinedNmuber {
  color: #999;
  margin-left: 4vw;
  margin-bottom: 1vh;
}
.cool-hr {
  margin: 0;
}
.scroll-container {
  height: 61vh;
  overflow: auto;
}
.friendList {
  display: flex;
  align-items: center;
  margin-top: 2vw;
  margin-left: 1vw;
  img {
    width: 50px;
    border-radius: 50%;
  }
  p {
    margin: 0 0 0 2vw;
  }
}
.preview {
  display: flex;
  flex-wrap: wrap;
  height: 9vh;
  background: #ccc;
  padding: 0 2vw;
  overflow: auto;
  .img-box {
    width: 50px;
    height: 50px;
    position: relative;
    margin: auto 0 auto 1vw;
    .fa-stack {
      font-size: 10px;
      position: absolute;
      top: 1px;
      right: 1px;
    }
    .fas {
      color: #fff;
    }
    .far {
      color: #000;
    }
    img {
      width: 50px;
      border-radius: 5px;
    }
  }
}
// 從相簿進入推高
.pushiOS {
  .q-card {
    bottom: 6.5vh;
  }
  .scroll-container {
    height: 51vh;
  }
}

@media (min-width: 600px) {
  .q-dialog__inner--minimized > div {
    max-width: none;
  }
}
</style>
